var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"srh-Filter_ItemHeader",class:{ 'srh-Filter_ItemHeader-expanded': _vm.toggleParent },on:{"click":_vm.toggleSection}},[_vm._t("default"),_vm._v(" "),_c('i',{class:['ka ka-chevronBottom srh-Filter_Icon',
             { 'srh-Filter_Icon-toggleChild': _vm.toggleParent }]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }